// Inventory Products Vuex

import state from './saleStates.js'
import * as getters from './saleGetters.js'
import * as mutations from './saleMutations.js'
import * as actions from './saleActions.js'

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
